/**
 * Created by hp on 2017/5/25.
 */
const defaults = {
    redpackMessage: {},
    redpackGrab: {},
    redpackUserObject: {},
    showRedpackGrabDialog: false,
    showRedpackUserDialog: false,
};

export default (state = defaults, action) => {
    switch(action.type){
        case 'SET_REDPACK_MESSAGE':
            return {...state, redpackMessage: action.preload};
        case 'SET_REDPACK_GRAB':
            return {...state, redpackGrab: action.preload};
        case 'SET_REDPACK_USER_OBJECT':
            return {...state, redpackUserObject: action.preload};
        case 'SHOW_REDPACK_GRAB_DIALOG':
            return {...state, showRedpackGrabDialog: true};
        case 'HIDE_REDPACK_GRAB_DIALOG':
            return {...state, showRedpackGrabDialog: false};
        case 'SHOW_REDPACK_USER_DIALOG':
            return {...state, showRedpackUserDialog: true};
        case 'HIDE_REDPACK_USER_DIALOG':
            return {...state, showRedpackUserDialog: false};
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/redpack.js